import React, { useState, useRef, useEffect } from 'react'
import { useAuth } from "../context/AuthContext";
import sortIcon from '../assets/sort.svg'
import checkIcon from '../assets/checkIcon.svg'
import '../styles/data-table.scss'

function TableHeader({id, label, rows, setRows, filterItems, setFilterItems}){ 
    const { meetingData } = useAuth()
    const [dropdown, setDropdown ] = useState(false)
    const [dropdownData, setDropdownData] = useState([])
    const uniqueValues = [...new Set(dropdownData?.map(item => item[id]))]
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    const dropdownRef = useRef(null)
    const innerRef = useRef(null)
    const dropdownList = id === 'date' ? months : uniqueValues

    //Load a click event to detect if clickevent is outside of header dropdown
    useEffect(() => {
        document.getElementById("dashboard").addEventListener("click", toggleDropdown)
        setDropdownData(meetingData) //Set meetingData to be parsed into dropdown components
    },[meetingData])

    //Toggle header dropdowns
    const toggleDropdown = (e) => { 
        (
            dropdownRef.current && 
            !dropdownRef.current.contains(e.target) &&
            !innerRef.current.contains(e.target)
        ) 
            ? setDropdown(false)
            : setDropdown(true)
    }

    //Sort rows from A -> Z and Z -> A
    const sortRows = (col, dir) => {
        const sortedData = [...rows].sort((a, b) => 
           dir === 'ascending'
            ? a[col] > b[col] ? 1 : -1 
            : a[col] < b[col] ? 1 : -1 
        )
        setRows(sortedData)
    }

    //Select items to include in the filterItems state array
    const toggleFilterItem = (item) => {     
        filterItems.includes(item)
            ? setFilterItems(filterItems.filter((i) => i !== item))
            : setFilterItems([...filterItems, item])
    }


    return(
        <th id={`${id}-header`} className={id}>
            <span>{label}</span>
            <img
                id={id}
                className="sort icon icon--small" 
                ref={dropdownRef}
                src={sortIcon} 
                alt={`Sort ${id}`} 
            />
            <div ref={innerRef} className={dropdown ? "filter-dropdown" : "hidden"}>
                <p onClick={() => sortRows(id, 'ascending')}>Sort A - Z</p>
                <p onClick={() => sortRows(id, 'descending')}>Sort Z - A</p>
                <span>Filter</span>
                {
                    dropdownList.map( (item, i) => {
                        return(
                            <div id={item} key={i} onClick={() => toggleFilterItem(item)} className='flex-row'> 
                                <img 
                                    className={filterItems.includes(item) ? "hidden-checkmark icon icon--small" : "icon icon--small" }
                                    src={checkIcon} 
                                    alt="Filter Item Selected" 
                                />
                                <p id={item}>{item}</p>
                            </div>
                        )
                    })
                }
            </div>
        </th>
    )
}

export default TableHeader